(() => {
  if (window.__ecloHorizontalSliderV1) return;
  window.__ecloHorizontalSliderV1 = true;
  const ROOT = '[data-eclo-hslider]';
  function enhance(root) {
    if (!root || root.dataset.ecloHsliderReady === 'true') return;
    const viewport = root.querySelector('[data-eclo-hslider-viewport]');
    if (!viewport) return;
    root.dataset.ecloHsliderReady = 'true';
    const controls = document.createElement('div');
    controls.className = 'eclo-hslider__controls';
    const lang = ((document.documentElement && document.documentElement.lang) || 'fr').toLowerCase();
    const isEnglish = lang.indexOf('en') === 0;
    const prevLabel = isEnglish ? 'Previous' : 'Précédent';
    const nextLabel = isEnglish ? 'Next' : 'Suivant';
    controls.innerHTML = '<button type="button" class="eclo-hslider__button" data-eclo-hslider-prev aria-label="' + prevLabel + '">←</button><button type="button" class="eclo-hslider__button" data-eclo-hslider-next aria-label="' + nextLabel + '">→</button>';
    root.appendChild(controls);
    const prev = controls.querySelector('[data-eclo-hslider-prev]');
    const next = controls.querySelector('[data-eclo-hslider-next]');
    const step = () => Math.max(viewport.clientWidth * 0.82, 240);
    const update = () => {
      const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 2);
      prev.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= max;
      controls.hidden = max <= 4;
    };
    prev.addEventListener('click', () => viewport.scrollBy({left: -step(), behavior:'smooth'}));
    next.addEventListener('click', () => viewport.scrollBy({left: step(), behavior:'smooth'}));
    viewport.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    requestAnimationFrame(update);
  }
  function init(scope=document) { scope.querySelectorAll(ROOT).forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
